import React from "react";
import { FaEraser, FaTrash, FaUndo } from "react-icons/fa";
import { PALETTE, SIZES } from "./strokes";

const toolButton = (active) =>
  `w-11 h-11 flex items-center justify-center rounded-xl text-lg transition-all ${
    active ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-700"
  }`;

const DrawToolbar = ({
  tool,
  color,
  sizeIndex,
  onPickColor,
  onPickSize,
  onPickEraser,
  onUndo,
  onClear,
}) => (
  <div className="bg-white rounded-2xl shadow-xl p-3 space-y-3">
    <div className="flex items-center justify-between">
      {PALETTE.map((c) => (
        <button
          key={c}
          aria-label={c}
          onClick={() => onPickColor(c)}
          className={`w-9 h-9 rounded-full border-2 transition-transform ${
            tool === "pen" && color === c
              ? "border-gray-900 scale-125"
              : "border-gray-200"
          }`}
          style={{ backgroundColor: c }}
        />
      ))}
    </div>
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {SIZES.map((s, i) => (
          <button
            key={s}
            aria-label={`size ${i + 1}`}
            onClick={() => onPickSize(i)}
            className={toolButton(sizeIndex === i)}
          >
            <span
              className="rounded-full bg-current"
              style={{ width: 6 + i * 6, height: 6 + i * 6 }}
            />
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <button
          aria-label="eraser"
          onClick={onPickEraser}
          className={toolButton(tool === "eraser")}
        >
          <FaEraser />
        </button>
        <button aria-label="undo" onClick={onUndo} className={toolButton(false)}>
          <FaUndo />
        </button>
        <button
          aria-label="clear"
          onClick={onClear}
          className={`${toolButton(false)} text-red-600`}
        >
          <FaTrash />
        </button>
      </div>
    </div>
  </div>
);

export default DrawToolbar;
